<template>
  <div>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="400px">
        <v-card color="grey lighten-2">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{dialog_baslik}}</v-toolbar-title>

            </v-toolbar>
          </v-flex>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout row="" wrap>

                <div class="flex md12">
                  <v-text-field label="Dizayn Tablo Adı" hide-details="" :color="color" v-model="ListInput.FaturaTabloAdi">
                  </v-text-field>
                  <v-text-field label="Açıklama" hide-details="" :color="color" v-model="ListInput.FaturaAciklama">
                  </v-text-field>
                  <v-select :items="xsltitems" v-model="ListInput.FaturaXsltId" clearable item-text="XsltAciklama"
                    item-value="FaturaId" label="xslt Dosyası Seç"></v-select>
                  <reportbrosablon ref="reportbrosablon" v-model="ListInput.FaturaPdfID " dizayngrupadi="Fatura"
                    objectname="Controllers.ReportBro.Invoice.InvoicePrint"></reportbrosablon>
                  <v-layout>
                    <v-radio-group v-model="ListInput.FaturaIcDis" hide-details="" label="Fatura Tipi">
                      <v-radio label="İç Hat" value="I"></v-radio>
                      <v-radio label="Dış Hat" value="D"></v-radio>
                      <v-radio label="Serbest" value="S"></v-radio>
                    </v-radio-group>
                    <v-radio-group v-model="ListInput.FaturaTLDoviz" hide-details="" label="TL/Döviz">
                      <v-radio label="TL" value="T"></v-radio>
                      <v-radio label="Döviz" value="D"></v-radio>
                    </v-radio-group>
                  </v-layout>
                </div>

              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div v-show="m === true">
              <v-btn id="bguncelle" color="blue darken-1" flat @click="Kaydet()">Güncelle</v-btn>
              <v-btn id="bsil" color="blue darken-1" flat @click="silsor()">Sİl</v-btn>
            </div>
            <div v-show="k === true">
              <v-btn v-if="k==true" id="bkaydet" color="blue darken-1" flat @click="Kaydet()">Kaydet</v-btn>
            </div>
            <v-btn color="blue darken-1" flat @click="vazgec()">VazgeÇ</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-toolbar dark color="info">
        <v-toolbar-title>Fatura Dizayn Tanımlama</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>
        <v-btn hidden="xs" flat @click="dizaynekle()"> Dizayn Ekle
          <v-icon right dark>add_box</v-icon>
        </v-btn>
      </v-toolbar>
    </v-layout>

    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>

      </v-card-title>
      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="dizaynitems" :search="search3">
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
          <tr @click="Getir(props.item)" item>
            <td class="text-xs-left">{{ props.item.FaturaId }}</td>
            <td class="text-xs-left">{{ props.item.FaturaTabloAdi }}</td>
            <td class="text-xs-left">{{ props.item.FaturaAciklama }}</td>
            <td class="text-xs-left">{{ props.item.FaturaTip }}</td>
            <td class="text-xs-left">{{ props.item.FaturaTLDoviz }}</td>

          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
        </v-alert>
      </v-data-table>
    </v-card>

    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
          :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>
      </v-card>

      <v-dialog v-model="dialog1" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Uyarı !</v-card-title>
          <v-card-text>{{dialogmessage1}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="info" flat @click.native="dialog1=false">İptal</v-btn>

            <v-btn color="info" flat @click="dizaynsil()">Tamam</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </template>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import reportbrosablon from "@/components/app/coper/comp/reportbrosablon.vue";



  export default {
    data() {
      return {

        pdfclass: null,
        dizayn: null,
        dizaynitems: [],
        xsltitems: [],
        ListInput: {
          FaturaId: null,
          SirketKodu: null,
          FaturaTip: null,
          FaturaTLDoviz: 'T',
          FaturaTabloAdi: null,
          FaturaAciklama: null,
          FaturaMailDosya: null,
          FaturaPdfDosya: null,
          FaturaIcDis: 'I',
          FaturaXsltDosya: null,
          FaturaXsltId: null,
          FaturaDetayOzet: null,
          FaturaPdfID: null,
        },


        tooltip: false,
        el: null,
        text1: null,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,

        yenikayit: false,

        headers: [{
            text: 'Fatura Id',
            value: 'FaturaId'
          },
          {
            text: 'Fatura Tablo Adı',
            value: 'FaturaTabloAdi'
          },
          {
            text: 'Açıklama',
            value: 'FaturaAciklama'
          },
          {
            text: 'Fatura Tip',
            value: 'FaturaTip'
          },
          {
            text: 'TL/Döviz',
            value: 'FaturaTLDoviz'
          }
        ],
        loading: false,
        color: 'orange darken-4',
        yedeksirket: [],
        items: [],
        search3: '',
        search: null,
        select: [],
        selected: '',
        m: false,
        k: false,
        dialog: false,
        dialog1: false,
        dialogmessage1: '',

        state: [],

        dialog_baslik: '',

        bankakod: '',
        bankaadi: '',
        progress: false,
        dictionary: {
          custom: {
            sirketkod: {
              required: () => 'Bu alan boş bırakılamaz',
            },
            sirketadi: {
              required: () => 'Bu alan boş bırakılamaz',
            }
          }
        }
      }
    },
    watch: {
      search(val) {
        val && this.carigetir(val)
      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {

      silsor() {
        this.dialogmessage1 = "Fatura Dizaynını silmek istediğinize emin misiniz?";
        this.dialog1 = true;
      },



      Getir(v) {

        this.yenikayit = false,
          this.k = false
        this.m = true
        this.ListInput.FaturaId = v.FaturaId
        this.ListInput.FaturaTip = v.FaturaTip
        this.ListInput.FaturaTLDoviz = v.FaturaTLDoviz
        this.ListInput.FaturaTabloAdi = v.FaturaTabloAdi
        this.ListInput.FaturaAciklama = v.FaturaAciklama
        this.ListInput.FaturaMailDosya = v.FaturaMailDosya
        this.ListInput.FaturaPdfDosya = v.FaturaPdfDosya
        this.ListInput.FaturaIcDis = v.FaturaIcDis
        this.ListInput.FaturaXsltDosya = v.FaturaXsltDosya
        this.ListInput.FaturaXsltId = v.FaturaXsltId
        this.ListInput.FaturaDetayOzet = v.FaturaDetayOzet
        this.ListInput.FaturaPdfID = v.FaturaPdfID
        // this.pdfclass.id=10
        this.dialog = true
        this.dialog_baslik = 'Fatura Dizayn Güncelle'

      },
      dizaynsil: dizaynsil,
      dizaynekle: dizaynekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
      vazgec: vazgec
    },
    beforeMount: beforeMount,
    components: {
      reportbrosablon
    },
    vazgec: vazgec
  }

  function vazgec() {
    this.dialog = false
  }


  function Kaydet() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.ListInput.SirketKodu = credentials.SirketKodu

    if (this.ListInput.FaturaIcDis == 'I' || this.ListInput.FaturaIcDis == 'D') {
      this.ListInput.FaturaTip = '0'
    } else if (this.ListInput.FaturaIcDis == 'S') {
      this.ListInput.FaturaTip = 'S'

    }



    var params = this.ListInput
    this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceMainTableSave', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      if (response.body.Status) {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
        this.dialog = false;
        this.dosyaokefatura = false
        this.dosyaokearsiv = false

        var params3 = {
          SirketKodu: credentials.SirketKodu,
          FaturaTip: null,
          DovizliFatura: false,
          HatTipi: false,
          TumFiltre: false
        }
        this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceMainTableList', params3, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.dizaynitems = response.body
        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable-InvoiceMainTableList'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-InvoiceMainTableList'
            this.snackbar = true
          }
        })


      } else {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
      }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = response.statusText
        this.snackbar = true
      }
    })
  }

  function dizaynekle() {


    this.ListInput.FaturaId = null,
      this.ListInput.FaturaTip = null,
      this.ListInput.FaturaTLDoviz = 'T',
      this.ListInput.FaturaTabloAdi = null,
      this.ListInput.FaturaAciklama = null,
      this.ListInput.FaturaMailDosya = null,
      this.ListInput.FaturaPdfDosya = null,
      this.ListInput.FaturaIcDis = 'I',
      this.ListInput.FaturaXsltDosya = null,
      this.ListInput.FaturaXsltId = null,
      this.ListInput.FaturaDetayOzet = null,
      this.ListInput.FaturaPdfID = null,


      this.dialog = true
    this.dialog_baslik = 'Dizayn Ekle';
    this.k = true;
    this.m = false;
  }

  function beforeMount() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var params3 = {
      SirketKodu: credentials.SirketKodu,
      FaturaTip: null,
      DovizliFatura: false,
      HatTipi: false,
      TumFiltre: false
    }
    this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceMainTableList', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.dizaynitems = response.body
    }, (response) => {
      if (response.status === 0) {
        this.progress = false
        this.text1 = 'Service Unavailable-InvoiceXsltTableList'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-InvoiceXsltTableList'
        this.snackbar = true
      }
    })

    var paramsxslt = {
      CompanyCode: credentials.SirketKodu
    }
    this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceXsltTableList', paramsxslt, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.xsltitems = response.body
    }, (response) => {
      if (response.status === 0) {
        this.progress = false
        this.text1 = 'Service Unavailable-InvoiceXsltTableList'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-InvoiceXsltTableList'
        this.snackbar = true
      }
    })
  }

  function dizaynsil() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params3 = {
      CompanyCode: credentials.SirketKodu,
      InvoiceID: this.ListInput.FaturaId
    }

    this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceMainTableDelete', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      if (response.body.Status) {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
        this.dialog1 = false;
        this.dialog = false;
        var params3 = {
          SirketKodu: credentials.SirketKodu,
          FaturaTip: null,
          DovizliFatura: false,
          HatTipi: false,
          TumFiltre: false
        }
        this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceMainTableList', params3, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.dizaynitems = response.body
        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          }
        })
      }

    }, (response) => {
      if (response.status === 0) {
        this.progress = false
        this.text1 = 'Service Unavailable-InvoiceXsltTableList'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-InvoiceXsltTableList'
        this.snackbar = true
      }
    })
  }

  function guncelle() {

    if (this.file.length > 0) {
      var cred = JSON.parse(window.localStorage.getItem('credentials'));
      let formData = new FormData();
      for (var i = 0; i < this.file.length; i++) {
        let file = this.file[i];
        formData.append('file[' + i + ']', file);
      }
      formData.append('CustomerCode', cred.AnaSirketKodu)
      formData.append('TransferType', '0')
      axios.defaults.baseURL = auth.API_URL;
      axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
      axios.post(auth.API_URL + 'api/TicketDefinitons/FileUploadxslt',
          formData, {
            headers: {
              Authorization: `Bearer ${auth.getAuthHeader()}`
            }
          }
        ).then((response) => {

          if (response.data == true) {

            this.load2 = true
            this.load = false
            this.text1 = "Xslt Aktarımları Tamamlandı"
            this.snackbar = true
          } else {
            this.text1 = "Xslt dosyalarınız aktarılamadı. Tekrar deneniyiniz."
            this.snackbar = true
          }
        })
        .catch(function () {});
    }

    if (this.file2.length > 0) {

      var cred = JSON.parse(window.localStorage.getItem('credentials'));
      let formData = new FormData();
      for (var i = 0; i < this.file2.length; i++) {
        let file = this.file2[i];
        formData.append('file[' + i + ']', file);
      }
      formData.append('CustomerCode', cred.AnaSirketKodu)
      formData.append('TransferType', '1')
      axios.defaults.baseURL = auth.API_URL;
      axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
      axios.post(auth.API_URL + 'api/TicketDefinitons/FileUploadxslt',
          formData, {
            headers: {
              Authorization: `Bearer ${auth.getAuthHeader()}`
            }
          }
        ).then((response) => {
          if (response.data == true) {
            this.ListInput.XsltAd1 = this.dosyayolu2;

            this.load2 = true
            this.load = false
            this.text1 = "Xslt Aktarımları Tamamlandı"
            this.snackbar = true
          } else {
            this.text1 = "Xslt dosyalarınız aktarılamadı. Tekrar deneniyiniz."
            this.snackbar = true
          }
        })
        .catch(function () {
          console.log('hata!!');
        });
    }

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.ListInput.SirketKodu = credentials.SirketKodu


    if (this.dosyaokearsiv == true) {
      this.ListInput.XsltAd = this.dosyayolu1;
    }

    if (this.dosyaokefatura == true) {
      this.ListInput.XsltAd1 = this.dosyayolu2;
    }

    var params = this.ListInput

    this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceXsltTableSave', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      if (response.body.Status) {

        this.text1 = response.body.ResponseMessage
        this.snackbar = true;
        this.dialog = false;
        this.dosyaokefatura = false;
        this.dosyaokearsiv = false;

        var params3 = {
          CompanyCode: credentials.SirketKodu
        }

        this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceXsltTableList', params3, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.xsltitems = response.body
        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          }
        })
      } else {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
      }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = response.statusText
        this.snackbar = true
      }
    })


  }
</script>

<style>
</style>